
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import reportMsgUt from "@/util/reportMsg";
    import {useRoute, useRouter} from "vue-router";
    import { Popup } from 'scvant';
     import utils from '@/util/index';

    interface State {
        point: ComputedRef<"N" | "Y">; // N 没有三种缺陷 Y 有三种缺陷
        isAccident: number; // 0不是事故车 1是事故车
        isFire: number; // 0不是事故车 1是事故车
        isWater: number; // 0不是事故车 1是事故车
        reportCode: string | null;
        channelType: string;
        logoUrl: string;
        protectTime: string;
        promiseMsg: string;
        reportMsg: object;
        templateCode: string;
        brandName: string;
        modelName: string;
        vin: string;
        reportGenDate: string;
        showProtect: boolean;
        showBatteryStatus: boolean;
        showPowerStatus: boolean;
        isXNY: boolean;
        isSF: any;
        productName: string;
        accidentFlag: number;// 0 非事故车 1 非重大事故 2 重大事故车
        showPromiseDes: string;
        rankDesc: any;
        rank: string | null;
        soh: string | null;
        sohDesc: string | null;
        chargeVoc: string | null;
        chargeVocDesc: string | null;
        brandLogo: string;
        tabIndex: number; // tab索引
    }

    export default defineComponent({
        name: "headTip",
        setup() {
            const {query} = useRoute();
            let state: State = reactive({
                point: "Y" as any,
                isAccident: 1,
                isFire: 1,
                isWater: 1,
                reportCode: '',
                channelType: `${query.channelType}` || '',
                logoUrl: '',
                protectTime: '90',
                promiseMsg: '',
                reportMsg: {},
                templateCode: '',
                brandName: '',
                modelName: '',
                vin: '',
                reportGenDate: '',
                showProtect: false,
                isXNY: false,
                isSF: -1,
                productName: `${query.productName || ''}`,
                accidentFlag: 2,
                showPromiseDes: '',
                showBatteryStatus: false,
                showPowerStatus: false,
                rankDesc: null,
                rank: null,
                soh: null,
                sohDesc: null,
                chargeVoc: null,
                chargeVocDesc: null,
                brandLogo: '',
                tabIndex: 0,
            })
            state.reportMsg = reportMsgUt;
            state.reportCode = `${query.reportCode}`;
            state.templateCode = `${query.templateCode}`;
            state.protectTime = state.channelType === 'jiaxuan' ? '100' : '90';
            // 获取路由器实例
            const router = useRouter()
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo);
            let isNormal: ComputedRef<{}> = computed<{}>(() => store.state.isNormal);
            let reportResultList: ComputedRef<{}> = computed<{}>(() => store.state.reportResultList);
            state.isSF = computed(() => {
                return store.state.isNormal
            });
            state.point = computed(() => {
                return store.state.isNormal ? 'N' : 'Y'
            })
            console.log('reportResultList:', reportResultList);
            // 享90天回购保障{{state.reportMsg.RpSRZ() ? '｜付费享1年３万公里保修' : ''}}
            let promiseDes = `享${state.protectTime}天回购保障`;
            if (state.reportMsg['Rp699']()) {
                promiseDes = `享${state.protectTime}天回购及重要部件赔付保障`;
            } else if (state.reportMsg['RpHC']()) {
                promiseDes = `享${state.protectTime}天赔付保障`;
            }
            state.showPromiseDes = `查看《${promiseDes}说明》`;
            state.promiseMsg = promiseDes + (state.reportMsg['RpSRZ']() ? '｜付费享1年3万公里保修' : '');
            watch(dataInfo, (data: any) => {
                const {
                        isAccident, 
                        isFire, 
                        isWater, 
                        reportConfigInfo, 
                        brandName, 
                        modelName, 
                        vin, 
                        reportDetectOrderVO, 
                        energyType,
                        productName,
                        accidentFlag, 
                        rankDesc, 
                        rank,
                        brandLogo,
                        batteryKaeriVO
                    } = data;
                state.logoUrl = reportConfigInfo ? reportConfigInfo.logoUrl : '';
                state.isAccident = accidentFlag > -1 ?  accidentFlag : isAccident ;
                state.isFire = isFire
                state.isWater = isWater
                state.brandName = brandName
                state.modelName = modelName
                state.vin = vin;
                state.reportGenDate = reportDetectOrderVO.reportGenDate
                state.isXNY = energyType === 2 ? true : false;
                state.rankDesc = rankDesc;
                state.rank = rank;
                state.brandLogo =  utils.replaceImageUrl(brandLogo);
                state.soh = batteryKaeriVO && batteryKaeriVO.soh;
                state.sohDesc = batteryKaeriVO && batteryKaeriVO.sohDesc;
                state.chargeVoc = batteryKaeriVO && batteryKaeriVO.chargeVoc;
                state.chargeVocDesc = batteryKaeriVO && batteryKaeriVO.chargeVocDesc;
                // console.log(productName);
                // console.log(accidentFlag);
                //第一版新版报告上线静态化中没有productName字段并且上线的是299相关报告，解析完为undefined,用事故排查检测
                if (!state.productName) {
                    state.productName = productName === undefined ? '事故排查检测' : (productName === null ? '' :productName); 
                }
                state.accidentFlag = accidentFlag;
            })
            function getHeadPromiseBgStyle(): object {
                let promiseStyle = {};
                if (state.reportMsg['RpHC']()) {
                    promiseStyle = {'head_promise_bg_hc': true};
                } else if (state.reportMsg['Rp699']()) {
                    promiseStyle = {'head_promise_bg_699': true};
                } else if (state.reportMsg['Rp499']()||state.reportMsg['RpZQYS']()) {
                    promiseStyle = {'head_promise_bg_499': true};
                } else {
                    promiseStyle = {'head_promise_bg_299': true};
                }
                return promiseStyle;
            }
            function getHeadResultBgStyle(): object  {
                let resultBgStyle = {};
                if (state.reportMsg['RpZQYS']) {
                    resultBgStyle = {'head_result_bg_pro': true,'result_bg_nosf': !state.isSF};
                } else {
                    if (state.isSF) {
                        resultBgStyle = {'head_result_sf_bg': true};
                    } else {
                        resultBgStyle = {'head_result_sf_bg_noguarantee': true,'result_bg_nosf': !state.isSF};
                    }
                }
                return resultBgStyle;
            }
            function getAccidentDes(): string  {
                let accidentDes = '';
                if (state.accidentFlag === undefined) {//走旧的逻辑
                    accidentDes = !state.isAccident ? '非事故车' : '事故车';
                } else {//根据accidentFlag判断
                    if (state.accidentFlag  === 0) {
                        accidentDes = '非事故车';
                    }  else if (state.accidentFlag  === 1) {
                         accidentDes = '事故车';
                    }  else if (state.accidentFlag  === 2) {
                        accidentDes = '重大事故车';
                    }
                }
                return accidentDes;
            }
            function getVectorIcon() {
                let vectorIcon = require("../../../assets/tocV4/headVector.png");
                return vectorIcon;
            }
            function getRightArrowIcon() {
                let arrowIcon = require("../../../assets/tocV4/headArrowRight.png");
                return arrowIcon;
            }
            function getPromiseMsgFont(): object  {
                let fontStyle = {};
                if (state.reportMsg['RpHC']()) {
                    fontStyle = {'head_promise_font_hc': true};
                } else if (state.reportMsg['Rp699']()) {
                    fontStyle = {'head_promise_font_699': true};
                } else if (state.reportMsg['Rp499']()||state.reportMsg['RpZQYS']()) {
                    fontStyle = {'head_promise_font_499': true};
                } else {
                    fontStyle = {'head_promise_font_299': true};
                }
                return fontStyle;
            }
            //获取等级标签图标
            function getResBoxLevelIcon() {
                let levelIcon = null;
                if (state.rank === 'S') {
                    levelIcon = require("../../../assets/tocV4/S_299.png");
                } else if (state.rank === 'C'){
                    levelIcon = require("../../../assets/tocV4/C_299.png");
                } else if (state.rank === 'D'){
                    levelIcon = require("../../../assets/tocV4/D_299.png");
                }
                return levelIcon;
            }
            function getResJiStyleIcon() {
                let jiIcon = require("../../../assets/tocV4/ji_299.png");
                return jiIcon;
            }

            return {
                state,
                router,
                dataInfo,
                isNormal,
                reportResultList,
                getAccidentDes,
                getHeadPromiseBgStyle,
                getHeadResultBgStyle,
                getVectorIcon,
                getRightArrowIcon,
                getResBoxLevelIcon,
                getResJiStyleIcon,
                getPromiseMsgFont,
            }
        },
        components: {
            [Popup.name]: Popup,
        },
        methods: {
            toExplain(desc) {
                if (desc === 'auth') {
                    this.router.push({
                        path: '/explainFreeAuth',
                        query: {
                            templateCode: this.state.templateCode
                        }
                    })
                } else {
                    this.router.push({
                        path: '/tocZQYExplainFreeCheck',
                        query: {
                            channelType: this.state.channelType,
                            templateCode: this.state.templateCode
                        }
                    })
                }
            },
            setShowProtect(){
                let lbParam = {
                    templateCode: this.state.templateCode
                }
                this.state.showProtect = !this.state.showProtect;
            },
            setShowBattery(type){
                this.state[type] = !this.state[type];
            },
            changeTab(index) {
                this.state.tabIndex = index;
            },
            sohImg () {
                let url = '';
                if (this.state.soh) {
                    let sn = Number(this.state.soh);
                    if (sn >= 85) {
                        url = require('../../../assets/tocZQY/batteryGreen.png');
                    } else if (sn >= 75 && sn < 85) {
                        url = require('../../../assets/tocZQY/batteryYellow.png');
                    } else {
                        url = require('../../../assets/tocZQY/batteryRed.png');
                    }
                }
                return url;
            },
            chargeVocImg () {
                let url = '';
                if (this.state.chargeVoc) {
                    if (this.state.chargeVoc == 'A') {
                    url = require('../../../assets/tocZQY/powerGreen.png');
                    } else if (this.state.chargeVoc == 'B') {
                    url = require('../../../assets/tocZQY/powerYellow.png');
                    } else {
                    url = require('../../../assets/tocZQY/powerRed.png');
                    }
                }
                return url;
            },
        }
    })
